const it = {
  // Header / Hero
  hero: {
    title: "Agenti AI su misura. Al tuo servizio.",
    subtitle: "Una taglia non va bene per tutti.",
  },

  // Theme toggle
  theme: {
    dark: "🌙 Modalità scura",
    light: "☀️ Modalità chiara",
  },

  // Error boundary
  errorBoundary: {
    title: "Qualcosa è andato storto",
    message: "Ci scusiamo, ma si è verificato un errore imprevisto.",
    refresh: "Aggiorna pagina",
  },

  // Agents section
  agents: {
    sectionTitle: "I nostri agenti AI",
    prevAgent: "Agente precedente",
    nextAgent: "Agente successivo",
    sliderLabel: "Slider agenti AI",
    watchOnYoutube: "Guarda su YouTube",
    comingSoon: "Prossimamente!",
  },

  // Agent options
  agentOptions: {
    proposeAgent: "Ordina il tuo agente!",
    proposedTagline: "Compila il modulo qui sotto per richiedere un agente personalizzato per le esigenze della tua azienda!",
    mediShiftTagline: "Pianificazione intelligente per team sanitari",
    frostDeskTagline: "Trasforma le note dei tecnici in una lista ricambi pronta all'azione — automaticamente.",
    athenaTagline: "Antiriciclaggio per commercialisti",
    pipTronixTagline: "Dalle procedure firmate all'esecuzione hands-free in fabbrica.",
  },

  // Order form section
  order: {
    sectionTitle: "Ordina un agente AI",
    selectAgent: "Seleziona un agente",
    proposeTitle: "Proponi un nuovo agente",
    orderTitle: "Ordina questo agente",
    close: "Chiudi",
    submit: "Invia richiesta",
    submitting: "Invio in corso...",
    clearForm: "Cancella modulo",
    successMessage: "Richiesta inviata con successo! Ti contatteremo presto.",
  },

  // Form labels & placeholders – "Propose" form
  proposeForm: {
    proposedAgentName: "Nome dell'agente proposto *",
    proposedAgentNamePlaceholder: "es. RetailPulse",
    industryDomain: "Settore / dominio",
    industryDomainPlaceholder: "es. Sanità",
    contactName: "Il tuo nome *",
    contactNamePlaceholder: "Nome completo",
    contactEmail: "Email *",
    contactEmailPlaceholder: "tu@azienda.com",
    company: "Azienda / organizzazione",
    companyPlaceholder: "Nome dell'azienda",
    role: "Ruolo / posizione",
    rolePlaceholder: "Il tuo ruolo",
    problemToSolve: "Problema da risolvere",
    problemToSolvePlaceholder: "In cosa dovrebbe aiutare questo agente?",
    desiredCapabilities: "Funzionalità desiderate",
    desiredCapabilitiesPlaceholder: "Funzionalità chiave, flussi di lavoro o attività",
    dataSources: "Fonti dati o sistemi",
    dataSourcesPlaceholder: "EHR, CRM, documenti, API, ecc.",
    integrations: "Integrazioni necessarie",
    integrationsPlaceholder: "Slack, Teams, Salesforce",
    successMetrics: "Metriche di successo",
    successMetricsPlaceholder: "Tempo risparmiato, precisione",
    timeline: "Tempistiche",
    timelinePlaceholder: "es. 6-8 settimane",
    budgetRange: "Budget indicativo",
    budgetRangePlaceholder: "5k€-20k€",
    additionalNotes: "Note aggiuntive",
    additionalNotesPlaceholder: "Altro da aggiungere?",
  },

  // Form labels & placeholders – "Existing agent" form
  existingForm: {
    contactName: "Il tuo nome *",
    contactNamePlaceholder: "Nome completo",
    contactEmail: "Email *",
    contactEmailPlaceholder: "tu@azienda.com",
    company: "Azienda / organizzazione",
    companyPlaceholder: "Nome dell'azienda",
    role: "Ruolo / posizione",
    rolePlaceholder: "Il tuo ruolo",
    useCase: "Caso d'uso previsto",
    useCasePlaceholder: "In cosa aiuterà?",
    keyWorkflows: "Flussi di lavoro da automatizzare",
    keyWorkflowsPlaceholder: "Pianificazione, triage, ecc.",
    dataSources: "Fonti dati o sistemi",
    dataSourcesPlaceholder: "EHR, CRM, documenti, API, ecc.",
    integrations: "Integrazioni necessarie",
    integrationsPlaceholder: "Slack, Teams, calendari, ecc.",
    expectedVolume: "Volume previsto",
    expectedVolumePlaceholder: "es. 500 richieste/settimana",
    timeline: "Tempistiche",
    timelinePlaceholder: "es. 4-6 settimane",
    budgetRange: "Budget indicativo",
    budgetRangePlaceholder: "5k€-20k€",
    preferredContact: "Metodo di contatto preferito",
    preferredContactPlaceholder: "Email, telefono, ecc.",
    additionalNotes: "Note aggiuntive",
    additionalNotesPlaceholder: "Altro da aggiungere?",
  },

  // Validation
  validation: {
    nameRequired: "Il nome è obbligatorio (minimo 2 caratteri)",
    emailRequired: "È richiesto un indirizzo email valido",
    proposedNameRequired: "Il nome dell'agente proposto è obbligatorio",
    fixErrors: "Correggi gli errori nel modulo prima di inviare.",
  },

  // Error messages
  errors: {
    unableToSubmit: "Impossibile inviare la richiesta. Riprova più tardi.",
    timeout: "Richiesta scaduta. Controlla la connessione e riprova.",
    network: "Errore di rete. Controlla la connessione internet e riprova.",
  },

  // FAQ
  faq: {
    sectionTitle: "Domande frequenti",
    items: [
      {
        question: "Chi c'è dietro CodeCat?",
        answer:
          "<strong>CodeCat è un'impresa al femminile</strong> fondata su una profonda esperienza pratica. Sono un'<strong>ex data scientist di Microsoft</strong> con un background che spazia tra data science, product management, linguistica e ingegneria del software. Dopo aver lavorato nei settori automotive, enterprise, sanitario, educativo e finanziario, oggi mi concentro sulla creazione di <strong>agenti AI personalizzati che risolvono problemi reali</strong> e portano risultati concreti.\n\n Sono supportata da un'eccezionale partner QA con otto anni di esperienza. È <strong>meticolosa, accurata e instancabilmente focalizzata sull'esperienza utente</strong>, assicurandosi che ogni soluzione che forniamo sia curata, affidabile e piacevole da usare.",
      },
      {
        question: "Cosa rende diversi i vostri agenti AI?",
        answer:
          "Molti strumenti AI non aiutano davvero perché sono generici e non si adattano al funzionamento reale della tua azienda. Noi costruiamo agenti AI <strong>fatti su misura per te</strong>. Si integrano con gli strumenti che già utilizzi, comprendono il linguaggio del tuo settore e <strong>si fanno carico delle attività ripetitive</strong> che ti rubano tempo.<br><br>Il risultato? <strong>Meno lavoro manuale, meno errori, tempi di risposta più rapidi</strong> e più spazio per te e il tuo team per concentrarvi sugli aspetti del business che contano davvero.",
      },
      {
        question: "Come funziona il processo?",
        answer:
          "Inizia con <strong>una conversazione</strong>. Ci racconti le sfide del tuo flusso di lavoro, noi proponiamo una soluzione agent su misura e, una volta approvata, la costruiamo, testiamo e distribuiamo. La maggior parte degli agenti diventa operativa entro <strong>4-8 settimane</strong> a seconda della complessità.",
      },
      {
        question: "Quanto costa?",
        answer:
          "I prezzi dipendono dalla complessità dell'agente, dalle integrazioni richieste e dal livello di supporto. Offriamo <strong>opzioni flessibili</strong>, da soluzioni una tantum a partnership continuative. Contattaci per un <strong>preventivo personalizzato. Nessun impegno richiesto</strong>.",
      },
      {
        question: "I miei dati sono al sicuro?",
        answer:
          "Sì, i tuoi dati sono <strong>assolutamente al sicuro</strong>. Trattiamo la sicurezza come un requisito fondamentale, non come un'aggiunta. Ogni agente AI che costruiamo segue rigorose <strong>pratiche standard del settore</strong> per la protezione dei tuoi dati, inclusa la crittografia e controlli di accesso rigorosi.<br><br>In parole semplici: i tuoi dati restano <strong>privati, protetti e nelle tue mani</strong>.",
      },
      {
        question: "Dove vi trovate?",
        answer:
          "Siamo in <strong>Canada</strong>, ma lavoriamo con clienti <strong>in tutto il mondo</strong>. Che tu sia un cliente locale o internazionale, possiamo costruire e distribuire agenti AI per la tua azienda. <strong>La geografia non è un ostacolo.</strong>",
      },
      {
        question: "Come posso iniziare?",
        answer:
          "Semplice! Basta <strong>selezionare un agente qui sopra</strong> e compilare il modulo di richiesta, oppure proponi la tua idea. Esamineremo la tua richiesta e ti ricontatteremo entro <strong>1-2 giorni lavorativi</strong> per discutere i prossimi passi.",
      },
    ],
  },

  // Footer
  footer: {
    copyright: "© 2026 CodeCat. Tutti i diritti riservati.",
  },
};

export default it;
